import React from 'react';

const TextArea = (props) => {
    return (
        <textarea className="p-input__text" id={props.id} rows={props.rows}
                  value={props.value} onChange={e => props.input(props.id, e.target.value)}/>
    )
};

export default TextArea